import request from '@/utils/request'

export default {
  createUser({ commit }, payload) {
    return request.post('/api/admin/users', payload).then(({ data }) => {
      commit('ADD_ELEMENT_TO_TOP_OF_THE_LIST', data.user)
      return data
    })
  },

  async getUsers({ commit }, params) {
    const { data } = await request.get('/api/admin/users', { params })
    if (data?.success) {
      commit('SET_LIST', data.users)
      commit('SET_TOTAL', data.total)
    }
    return data
  },

  updateUser({ commit }, payload) {
    const { _id, ...body } = payload
    return request.put(`/api/admin/users/${_id}`, body).then(({ data }) => {
      commit('UPDATE_ELEMENT_IN_LIST', payload)
      return data
    })
  },

  async deleteUser({ commit }, payload) {
    const { _id } = payload
    const { data } = await request.delete(`/api/admin/users/${_id}`)
    if (data?.success) {
      commit('DELETE_ELEMENT_IN_LIST', payload)
    }
    return data
  },
}
